import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const DigitalHealthServicesProduct = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Digital Health Services', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Digital Health Services " 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
             <section class="service-details section-space">
                   <div class="container">
                       <div class="row flex-xl-row flex-column-reverse">
                           <div class="col-xl-4">
                               <div class="sidebar sidebar-rr-sticky">
                                   <div class="sidebar__widget-service mb-30">
                                   <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
       
                                   </div>
       
                                   <div class="sidebar__widget-contact__service text-center">
                                       <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                                       <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
       
                                       <Link to="/contact-us#" class="rr-btn">
                                           <span class="btn-wrap">
                                               <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                               <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                                           </span>
                                       </Link>
                       </div>
                               </div>
                           </div>
                           <div class="col-xl-8">
                               <div class="service-details__content">
                                   <div class="service-details__content-media mb-20">
                                       <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                                   </div>
                                   <div className="content-container">
  <h3 className="section-title">
    <i className="fa-solid fa-laptop-medical text-primary"></i> Digital Health Services
  </h3>

  <p className="document-description">
    The increasing prevalence of <strong>Software as a Medical Device (SaMD)</strong> or as part of a device, often incorporating <strong>AI, IoT, mobile apps, or telemedicine</strong>, has led to evolving regulatory requirements and heightened information security concerns. These challenges demand a comprehensive approach to compliance and development.
  </p>

  <h4 className="document-title">
    <i className="fa-solid fa-building text-secondary"></i> SQUARE MEDTECH Expertise in Digital Health Solutions
  </h4>
  <p className="document-description">
    At <strong>SQUARE MEDTECH</strong>, we specialize in assisting medical device developers to navigate these complexities. Our dedicated team for digital health solutions combines regulatory expertise and software development skills under one roof, ensuring seamless project support.
  </p>

  <h5 className="sub-title">
    <i className="fa-solid fa-microchip text-info"></i> Key Areas of Expertise:
  </h5>
  <ul className="expertise-list">
    <li>
    <span><i class="fa-solid fa-check"></i></span>
      <strong>Development Processes:</strong> Insight into the unique aspects of developing medical software.
    </li>
    <li>
    <span><i class="fa-solid fa-check"></i></span>
      <strong>Regulatory Landscape:</strong> In-depth knowledge of regulatory requirements for medical software and health data management.
    </li>
    <li>
    <span><i class="fa-solid fa-check"></i></span>
      <strong>Technical Tools:</strong> Familiarity with the necessary tools and technologies to develop and secure digital health solutions.
    </li>
  </ul>

  <p className="document-description">
    Our integrated approach ensures that your digital health projects are not only compliant with current regulations but also optimized for performance and security.
  </p>

  <h4 className="document-title">
    <i className="fa-solid fa-handshake text-primary"></i> How SQUARE MEDTECH Can Support You:
  </h4>
  <ul className="support-list">
    <li>
    <span><i class="fa-solid fa-check"></i></span>
      <strong>Develop:</strong> The unique aspects of medical software.
    </li>
    <li>
    <span><i class="fa-solid fa-check"></i></span>
      <strong>Compliance:</strong> Fulfill the regulatory requirements for medical software and health data management.
    </li>
    <li>
    <span><i class="fa-solid fa-check"></i></span>
      <strong>Security:</strong> Take responsibility for developing and securing digital health solutions.
    </li>
  </ul>
</div>

                               </div>
                           </div>
                       </div>
                   </div>
               </section>
       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Digital Health Solutions:</h4>
                    <ul class="color-white mb-0">
                      <li>Cybersecurity</li>
                      <li>Data Protection</li>
                      <li>Digital Health Services & Consultations</li>
                    </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Digital Health Solutions:</h4>
                              <ul class="color-white mb-0">
                                <li>Regulatory Compliance</li>
                                <li>Data Management Consulting</li>
                                <li>Medical Software Development</li>
                              </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
